import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';
import { User } from 'msal';
// import { Client } from '@microsoft/microsoft-graph-client';
import * as jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class SsoAuthService {

  public authenticated: boolean;
  // graphClient: Client | null = null;
  token: any | null = null;

  constructor(private msalService: MsalService) {
    this.authenticated = false;
  }

  async getAccessToken(): Promise<string> {

    if (this.token) {
      return this.token;
    }

    this.token = await this.msalService.acquireTokenSilent(environment.OAuthSettings.scopes).catch((reason) => {
      console.log('acquireTokenSilent failed', JSON.stringify(reason, null, 2));
    });

    return this.token;

  }

  async getDecodedToken() {

    const token = await this.getAccessToken();

    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  getAuthUser(): any {
    const user: User = this.msalService.getUser();
    return user;
  }
/*
  async getGraphClient(): Promise<boolean> {

    if (this.graphClient) {
      return true;
    }

    if (!this.graphClient) {

      const t = await this.getAccessToken();

      this.graphClient = await Client.init({
        authProvider: (done) => {

          if (t) {
            done(null, t);
          } else {
            done('Could not get an access token', null);
          }

        }
      });

      return this.graphClient !== null;

    } else {

      return false;

    }

  }

  async getEmployee() {

    let loaded = true;
    if (!this.graphClient) {
      loaded = await this.getGraphClient();
    }

    if (loaded) {
      const graphUser = await this.graphClient.api('/me').get();
      return graphUser;
    }

    return null;

  }

  async getEmployeeID(): Promise<any> {

    let loaded = true;
    if (!this.graphClient) {
      loaded = await this.getGraphClient();
    }

    if (loaded) {
      const employeeID = await this.graphClient.api('/me/employeeId').get();
      return employeeID;
    }

    return null;

  }

  */

  logout() {
    this.msalService.logout();
  }

}
